/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillChargerDefinitionLinksResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeBackfillChargerDefinitionLinksCommand, serializeBackfillChargerDefinitionLinksResult, type BackfillChargerDefinitionLinksCommand, type BackfillChargerDefinitionLinksResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /backfills/charger-definition-links
 */
export interface ChargerDefinitionLinksRequestBuilder extends BaseRequestBuilder<ChargerDefinitionLinksRequestBuilder> {
    /**
     * BackfillChargerDefinitionLinks
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillChargerDefinitionLinksResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: BackfillChargerDefinitionLinksCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillChargerDefinitionLinksResult | undefined>;
    /**
     * BackfillChargerDefinitionLinks
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: BackfillChargerDefinitionLinksCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargerDefinitionLinksRequestBuilderUriTemplate = "{+baseurl}/backfills/charger-definition-links";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargerDefinitionLinksRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ChargerDefinitionLinksRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillChargerDefinitionLinksResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBackfillChargerDefinitionLinksCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
